// @flow
import React from "react"
import { compose } from "react-apollo"
import { Prompt } from "react-router-dom"
import { Helmet } from "react-helmet"
import { Toolbar, Heading } from "../UI/Toolbar"
import SlideForm from "./SlideForm"
import queries from "./queries"
import { queries as S3Queries } from "../S3"
import Loader from "../UI/Loader"
import handleSubmit from "./handleSubmit"
import { confirmDeletePath } from "./helpers"

import type { SlideFormViewProps } from "./types"

type State = {
  isBlocking: boolean,
  uploadErrorMessage: ?string,
  uploadFailed: boolean,
  uploading: boolean,
  newAssetId: ?string
}

class SlideFormView extends React.Component<SlideFormViewProps, State> {
  refreshUploadTimeout: ?number

  constructor(props) {
    super(props)
    this.state = {
      isBlocking: false,
      uploadErrorMessage: null,
      uploadFailed: false,
      uploading: false,
      newAssetId: null
    }
  }

  handleChange(e) {
    this.setState(() => ({ isBlocking: true }))
  }

  handleFileDrop = async (files: Array<File>) => {
    const { createAssetUploadURL, createAsset } = this.props

    const file = files[0] // We're only supporting a single file upload and ignoring all others.
    if (!file) {
      this.setState(() => ({ uploadErrorMessage: "No valid file found." }))
      return
    }

    const { data } = await createAssetUploadURL(file.name, file.type)
    const { signedURL, fileKey } = data.createAssetUploadURL

    this.setState(() => ({
      uploading: true,
      uploadFailed: false,
      uploadErrorMessage: null
    }))
    try {
      await fetch(signedURL, { method: "PUT", body: file })
      const { data } = await createAsset(fileKey, file.type)
      this.setState(() => ({
        uploading: false,
        newAssetId: data.createAsset.id
      }))
    } catch (err) {
      this.setState(() => ({
        uploading: false,
        uploadFailed: true,
        uploadErrorMessage: err
      }))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { details } = this.props
    if (
      prevProps.details &&
      prevProps.details.loading &&
      details &&
      !details.loading
    ) {
      this.setState(() => ({ isBlocking: false }))
    }
  }

  render() {
    const {
      createSlide,
      updateSlide,
      attractLoopId,
      history: { push },
      match: { url, params: { id } },
      details
    } = this.props
    const { isBlocking, uploading, uploadErrorMessage, newAssetId } = this.state
    const assetId = details && details.slide && details.slide.assetId
    const mediaURL = details && details.slide && details.slide.mediaURL
    const currentAssetId = newAssetId || assetId || null
    return (
      <div>
        <Helmet>
          <title>
            {`Slide - ${details
              ? `${details.slide ? details.slide.title : "Editing"}`
              : "New"}`}
          </title>
        </Helmet>
        <Prompt
          when={isBlocking}
          message={location =>
            `Are you sure you want to leave this form and lose any unsaved changes?`}
        />
        <Loader loading={details ? details.loading : false}>
          <Toolbar secondary={true}>
            <Heading secondary={true}>
              {id && details ? (
                `Editing: ${details.slide ? details.slide.title : ""}`
              ) : (
                "New Slide"
              )}
            </Heading>
          </Toolbar>
          <SlideForm
            loading={details ? details.loading : true}
            initialValues={details ? details.slide : {}}
            onSubmit={handleSubmit(
              attractLoopId,
              id,
              createSlide,
              updateSlide,
              () => {
                this.setState(() => ({ isBlocking: false }))
                push(`/admin/attract-loops/${attractLoopId}/slides`)
              }
            )}
            onChange={e => this.handleChange(e)}
            handleCancel={event => {
              event.preventDefault()
              push(`/admin/attract-loops/${attractLoopId}/slides`)
            }}
            handleDelete={async event => {
              event.preventDefault()
              await this.setState(() => ({
                isBlocking: false
              }))
              push(confirmDeletePath(url, attractLoopId, id))
            }}
            isNew={id ? false : true}
            id={id}
            uploading={uploading}
            uploadErrorMessage={uploadErrorMessage}
            onFileDrop={this.handleFileDrop}
            assetId={currentAssetId}
            existingAssetURL={mediaURL}
          />
        </Loader>
      </div>
    )
  }
}

export default compose(
  queries.withSlideFormDetails,
  queries.mutateCreateSlide,
  queries.mutateUpdateSlide,
  queries.mutateCreateAsset,
  S3Queries.mutateCreateSignedUploadURL
)(SlideFormView)



// WEBPACK FOOTER //
// ./src/Slides/SlideFormView.js